import React, { useEffect, useState } from "react";
import { toAbsoluteUrl, decrypt } from "../../helpers/Reusable";
import { getCookie } from "../../helpers/CookieComponent";
import { apiHeader, postData } from "../../helpers/ApiHelper";
import { getFCMToken } from "../../firebase";
import ClipLoader from "react-spinners/ClipLoader";

const NewsAlerts = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const lastShownDate = localStorage.getItem("newsPopupDate");
    const todayDate = new Date().toISOString().split("T")[0]; // Format: YYYY-MM-DD

    if (lastShownDate !== todayDate) {
      setShowPopup(true);
    }
  }, []);

  const handleClosePopup = () => {
    const todayDate = new Date().toISOString().split("T")[0];
    localStorage.setItem("newsPopupDate", todayDate);
    setShowPopup(false);
  };

  const handleAllow = async () => {
    setLoading(true);
    try {
      const token = await getFCMToken();
      console.log("FCM Token:", token);
      if (token) {
        const userIdCookie = getCookie("userId");
        const userId = userIdCookie ? decrypt(userIdCookie) : "";

        await postData(
          "user/save/fcm",
          { token, userId },
          apiHeader(false)
        );
      }
    } catch (error) {
      console.error("Error saving FCM token:", error);
    }
    setLoading(false);
    handleClosePopup();
  };

  if (!showPopup) return null;

  return (
    <>
      <div className="w-full fixed top-0 z-[9999] h-screen overflow-x-hidden overflow-y-auto bg-form getintouch">
        <div className="w-[70%] md:w-[40%] py-[3%] px-[5%] mx-auto relative top-1/2 transform -translate-y-1/2 form-box">
          <img
            className="w-[30%] mb-[3%] mx-auto sm:w-[40%] md:w-[30%] lg:w-[20%]"
            src={toAbsoluteUrl("media/img/logo/main-logo.svg")}
            alt=""
          />
          <h1 className="text-center">Get news alerts from</h1>
          <h1 className="mb-[5%] text-center">GCC Law Help on your desktop</h1>
          <div className="w-full justify-center gap-5 flex">
            <button 
            onClick={handleClosePopup} 
            className="na-nothanks-btn">
              No thanks
            </button>
            <button
              onClick={handleAllow}
              disabled={loading}
              className="px-[5%] py-[1%] na-allow-btn flex items-center justify-center gap-2"
            >
              {loading ? (
                <>
                  <span>Please wait...</span>
                  <ClipLoader size={16} color="#fff" />
                </>
              ) : (
                "Allow"
              )}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewsAlerts;
